$( window ).on( "load", function() {

  const audioPlayers = {};
  
  document.querySelectorAll(".audio-player").forEach((audioPlayer, index) => {
  const audio = new Audio(audioPlayer.dataset.audioSrc);
  audioPlayers[index] = { audio, playBtn: audioPlayer.querySelector(".controls .toggle-play") };
  
  console.dir(audio);
  
  audio.addEventListener("loadeddata", () => {
      audio.volume = 0.75;
  }, false);
  
  const timeline = audioPlayer.querySelector(".timeline");
  timeline.addEventListener("click", e => {
      const timelineWidth = window.getComputedStyle(timeline).width;
      const timeToSeek = e.offsetX / parseInt(timelineWidth) * audio.duration;
      audio.currentTime = timeToSeek;
  }, false);
  
  const volumeSlider = audioPlayer.querySelector(".controls .volume-slider");
  volumeSlider.addEventListener('click', e => {
      const sliderWidth = window.getComputedStyle(volumeSlider).width;
      const newVolume = e.offsetX / parseInt(sliderWidth);
      audio.volume = newVolume;
      volumeSlider.querySelector(".volume-percentage").style.width = newVolume * 100 + '%';
  }, false);
  
  setInterval(() => {
      const progressBar = audioPlayer.querySelector(".progress");
      progressBar.style.width = audio.currentTime / audio.duration * 100 + "%";
  }, 500);
  
  audioPlayers[index].playBtn.addEventListener("click", () => {
      // Pause all other audio players
      Object.keys(audioPlayers).forEach((key) => {
          if (key !== index.toString()) {
              audioPlayers[key].audio.pause();
              audioPlayers[key].playBtn.classList.remove("pause");
              audioPlayers[key].playBtn.classList.add("play");
          }
      });
  
      // Toggle play/pause for the current audio
      if (audio.paused) {
          audio.play().then(() => {
              audioPlayers[index].playBtn.classList.remove("play");
              audioPlayers[index].playBtn.classList.add("pause");
          }).catch((error) => {
              console.error("Error attempting to play audio:", error);
          });
      } else {
          audio.pause();
          audioPlayers[index].playBtn.classList.remove("pause");
          audioPlayers[index].playBtn.classList.add("play");
      }
  }, false);
  
  audioPlayer.querySelector(".volume-button").addEventListener("click", () => {
      const volumeEl = audioPlayer.querySelector(".volume-container .volume");
      audio.muted = !audio.muted;
      if (audio.muted) {
      volumeEl.classList.remove("icono-volumeMedium");
      volumeEl.classList.add("icono-volumeMute");
      } else {
      volumeEl.classList.add("icono-volumeMedium");
      volumeEl.classList.remove("icono-volumeMute");
      }
  });
  
  function updateTimeDisplay() {
      const currentTime = audio.currentTime;
      const formattedTime = getTimeCodeFromNum(currentTime);
      const timeDisplayDiv = audioPlayer.querySelector(".time-seconds");
      timeDisplayDiv.textContent = formattedTime;
  }
  
  setInterval(updateTimeDisplay, 500);
  
  });
  
  function getTimeCodeFromNum(num) {
      let seconds = parseInt(num);
      let minutes = parseInt(seconds / 60);
      seconds -= minutes * 60;
      const hours = parseInt(minutes / 60);
      minutes -= hours * 60;
  
      return `${String(minutes).padStart(2, '0')}.${String(seconds).padStart(2, '0')}s`;
  }
  
});